// extracted by mini-css-extract-plugin
export default {"innerContainer":"debit-note-creation_innerContainer__gntAs","header":"debit-note-creation_header__o0k+Q","dropdownContainer":"debit-note-creation_dropdownContainer__atbZe"};